import React from "react";
import _ from "lodash";
import { AutoPilotAPI } from "apis";
import AutoPilotConfigControl from "./auto-pilot/AutoPilotConfigControl";
import ModalWrapper from "../common/ModalWrapper";
import { notify } from "react-notify-toast";
import Checkbox from "../common/Checkbox";

class UnitAPConfigViewer extends React.Component {
  constructor(props) {
    super(props);

    const { config, defaultConfig, updatedAt, unitId } = props;

    this.state = {
      // isLoading: false,
      // errMsg: null,
      unitId,

      config,
      defaultConfig,
      updatedAt,

      isReviewModalOpened: false,
      finalConfig: null,

      // A checkbox in preview modal to control whether autopilot should iterate immediately
      // only open up to unit level for now
      shouldForceIterate: false,
      // A checkbox in preview modal to control whether autopilot should force resegmentation
      // only open up to unit level for now
      shouldForceResegment: false,

      isSaving: false,
      saveErrMsg: null,
    };

    this.handleSaveConfig = this.handleSaveConfig.bind(this);
    this.handleConfirmSaveConfig = this.handleConfirmSaveConfig.bind(this);
    this.handleOpenReviewModal = this.handleOpenReviewModal.bind(this);
    this.handleCloseReviewModal = this.handleCloseReviewModal.bind(this);
    this.toggleShouldForceIterate = this.toggleShouldForceIterate.bind(this);
    this.toggleShouldForceResegment =
      this.toggleShouldForceResegment.bind(this);
  }

  handleOpenReviewModal() {
    this.setState({
      isReviewModalOpened: true,
    });
  }

  handleCloseReviewModal() {
    this.setState({
      isReviewModalOpened: false,
      finalConfig: null,
      saveErrMsg: null,
    });
  }

  handleSaveConfig({ config }) {
    // Show review modal first!
    // save when confirmed
    const { unitId, networkId } = this.state;
    console.log("Save config", config, networkId, unitId);

    let finalConfig = _.cloneDeep(config);
    // Important! special case! Added extra outer layer of array
    if (_.has(finalConfig, "prophet.benchmark_abuse_sizes")) {
      const bas = finalConfig.prophet.benchmark_abuse_sizes;
      finalConfig.prophet.benchmark_abuse_sizes = [bas];
    }

    // find all nested keys (ex. "cst_x_setting.xxx")
    // NOT nested objects!!
    const prophetKeys = _.keys(finalConfig.prophet);
    const nestedObjectKeys = _.filter(prophetKeys, (k) => {
      return k.split(".").length > 1;
    });
    if (nestedObjectKeys.length > 0) {
      _.forEach(nestedObjectKeys, (nestedKey) => {
        const keyParts = nestedKey.split(".");
        const nestedValue = _.get(finalConfig, ["prophet", nestedKey]);
        _.set(finalConfig, ["prophet", keyParts[0], keyParts[1]], nestedValue);
        _.unset(finalConfig, ["prophet", nestedKey]);
      });
    }

    // Important! Remove some ui only tags
    // custom segmentation
    if (finalConfig.segmentation) {
      if (finalConfig.segmentation.custom_segmentation) {
        const segs = finalConfig.segmentation.custom_segmentation.segments;
        finalConfig.segmentation.custom_segmentation.segments = _.map(
          segs,
          (s) => {
            s = _.omit(s, "isEditable");
            return s;
          }
        );
      }
    }

    this.setState({ finalConfig });

    this.handleOpenReviewModal();
  }

  async handleConfirmSaveConfig() {
    if (this.state.isSaving) {
      return;
    }

    const { unitId, finalConfig } = this.state;

    this.setState({ isSaving: true, saveErrMsg: null });

    try {
      const resp = await AutoPilotAPI.updateAutoPilotConfig({
        unitId,
        config: finalConfig,
        commandOptions: {
          shouldForceIterate: this.state.shouldForceIterate,
          shouldForceResegment: this.state.shouldForceResegment,
        },
      });

      console.log("updated!!!");
      console.log(resp);
      notify.show("Config saved! Automatically reloading page...", "success");

      setTimeout(() => {
        window.location.reload(false);
      }, 2000);
    } catch (err) {
      console.log("uopdae failedddd!!!");
      console.log(err);
      notify.show("Failed to save", "error");

      console.log("Error saving auto pilot config", err);
      this.setState({
        saveErrMsg: typeof err === "object" ? err.toString() : err,
      });
    }

      this.setState({
        isSaving: false,
        config: _.cloneDeep(finalConfig), // Clear diffs to prevent beforeunload alert
      });
  }

  toggleShouldForceIterate(shouldForceIterate) {
    console.log("toggle shouldForceIterate", shouldForceIterate);

    this.setState({
      shouldForceIterate,
    });
  }

  toggleShouldForceResegment(shouldForceResegment) {
    console.log("toggle shouldForceResegment", shouldForceResegment);

    this.setState({
      shouldForceResegment,
    });
  }

  render() {
    const {
      config,
      defaultConfig,
      updatedAt,
      shouldForceIterate,
      shouldForceResegment,
      unitId,
    } = this.state;
    const { networkId } = this.props;

    if (config) {
      return (
        <>
          <AutoPilotConfigControl
            unitId={unitId}
            networkId={networkId}
            isUnitConfig={!!unitId}
            config={config}
            defaultConfig={defaultConfig}
            handleSaveConfig={this.handleSaveConfig}
            updatedAt={updatedAt}
          ></AutoPilotConfigControl>

          <ModalWrapper
            isOpen={this.state.isReviewModalOpened}
            showCloseFooter={false}
            handleClose={this.handleCloseReviewModal}
            customOverlayStyle={{ zIndex: 100 }}
            width="60%"
            title="Preview Config"
          >
            <div>
              <div
                className="border overflow-y-auto"
                style={{ maxHeight: "320px" }}
              >
                <pre>{JSON.stringify(this.state.finalConfig, null, 2)}</pre>
              </div>

              {unitId && (
                <div className="rounded mt-4 bg-orange-200 px-2 py-3 leading-none">
                  <div className="mb-2 text-sm text-orange-800">
                    If there are urgent changes in the config that needs to be
                    affected immediately, check the box below:
                  </div>
                  <label
                    className={
                      this.state.isSaving
                        ? "cursor-not-allowed"
                        : "cursor-pointer"
                    }
                  >
                    <Checkbox
                      isChecked={shouldForceIterate}
                      isDisabled={this.state.isSaving}
                      onChange={this.toggleShouldForceIterate}
                    ></Checkbox>

                    <span className="ml-2 align-middle text-sm font-semibold text-gray-700 hover:text-gray-800">
                      Force AutoPilot to iterate ASAP
                    </span>
                  </label>
                </div>
              )}

              {unitId && (
                <div className="rounded mt-4 bg-red-200 px-2 py-3 leading-none">
                  <div className="mb-2 text-sm text-red-800">
                    To force resegmentation{" "}
                    <i>(beware of performance implications)</i>:
                  </div>
                  <label
                    className={
                      this.state.isSaving
                        ? "cursor-not-allowed"
                        : "cursor-pointer"
                    }
                  >
                    <Checkbox
                      isChecked={shouldForceResegment}
                      isDisabled={this.state.isSaving}
                      onChange={this.toggleShouldForceResegment}
                    ></Checkbox>

                    <span className="ml-2 align-middle text-sm font-semibold text-gray-700 hover:text-gray-800">
                      Force resegment
                    </span>
                  </label>
                </div>
              )}

              <div className="mt-4 flex flex-row-reverse items-center">
                <div>
                  <button
                    type="button"
                    className="rounded shadow bg-blue-500 px-4 py-2 font-semibold text-white hover:bg-blue-700"
                    onClick={this.handleConfirmSaveConfig}
                  >
                    {this.state.isSaving ? "Saving..." : "Confirm save"}
                  </button>
                </div>
                <div>
                  <button
                    type="button"
                    disabled={this.state.isSaving}
                    className={`px-4 py-2 text-blue-700 ${
                      this.state.isSaving ? "cursor-not-allowed" : ""
                    }`}
                    onClick={this.handleCloseReviewModal}
                  >
                    Cancel
                  </button>
                </div>
                <div className="text-red-600">{this.state.saveErrMsg}</div>
              </div>
            </div>
          </ModalWrapper>
        </>
      );
    }

    return "";
  }
}

export default UnitAPConfigViewer;
